export default "__VITE_ASSET__CTHcXiiA__"